// extracted by mini-css-extract-plugin
export default {"loadingError":"loadingErrorFallback_loadingError--s_f_I"};